import { render } from "./PolicyBpmCard.vue?vue&type=template&id=fcf1a968"
import script from "./PolicyBpmCard.vue?vue&type=script&lang=js"
export * from "./PolicyBpmCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__